import clsx from 'clsx'

import { Spinner } from '@wartek-id/spinner'

const SpinnerLoading = ({
  isLoading,
  className,
}: {
  isLoading: boolean
  className?: string
}) =>
  isLoading && (
    <div className={clsx('w-full flex justify-center', className)}>
      <Spinner />
    </div>
  )

export default SpinnerLoading
